<template>
  <div :class="[$style.wrapper]" :style="{ backgroundImage: `url('${image}')` }">
    <template v-if="start">
      <div :class="$style.mathPerson">
        <div :class="$style.wow" v-if="currentPerson === 'art'">
      <span>Ну, ничего себе история!
        <br/><br/>
        Предлагаю написать пост о наших приключениях и заодно рассказать, что мы поняли.</span>
        </div>
        <div :class="$style.letsStart" v-if="currentPerson === 'bio'">
          <span>Да, давайте!</span>
        </div>
        <div :class="$style.start" v-if="currentPerson === 'math'">
          <span>Я начну:</span>
          <Button :class="$style.button" text="ПРОЙТИ ТЕСТ" @click="start = false"/>
        </div>
      </div>
      <div :class="$style.bioPerson">
        <div :class="$style.letsStart" v-if="currentPerson === 'math' || currentPerson === 'art'">
          <span>Да, давайте!</span>
        </div>
        <div :class="$style.start" v-if="currentPerson === 'bio'">
          <span>Я начну:</span>
          <Button :class="$style.button" text="ПРОЙТИ ТЕСТ" @click="start = false"/>
        </div>
      </div>
      <div :class="$style.artPerson">
        <div :class="$style.wow"  v-if="currentPerson === 'math' || currentPerson === 'bio'">
      <span>Ну, ничего себе история!
        <br/><br/>
        Предлагаю написать пост о наших приключениях и заодно рассказать, что мы поняли.</span>
        </div>
        <div :class="$style.start" v-if="currentPerson === 'art'">
          <span>Я начну:</span>
          <Button :class="$style.button" text="ПРОЙТИ ТЕСТ" @click="start = false"/>
        </div>
      </div>
    </template>
    <Tablet :os="true" v-if="!start">
      <TaskWindow :class="$style.test" title="Тест">
        <div :class="$style.testContent" v-if="test">
          <div :class="$style.questions">
            <span :class="$style.questionsDesc">Выбери верное утверждение:</span>
            <template v-for="(question, index) in questions.questions">
              <label :for="index" :class="[$style.container, answerResult && $style.correct]"
                     :key="index">
                <template>{{question}}</template>
                <input :id="index" name="connect" type="radio" :value="index"
                       v-model="currentAnswer"/>
                <span :class="$style.checkmark"></span>
              </label>
            </template>
          </div>
          <Button :class="$style.testButton" text="продолжить" v-if="isCorrectAnswer()"
                  @click="next"/>
        </div>
        <div :class="$style.testContent" v-if="showResult">
          <div :class="$style.textWrap">
            <span :class="$style.title">Набранные баллы:</span>
            <span :class="$style.result">{{scoreText}}</span>
          </div>
          <Button text="Перейти в хаб" @click="commitResult"/>
        </div>
      </TaskWindow>
    </Tablet>
  </div>
</template>

<script>
import plural from '@/utils/plural'

import Tablet from '@/components/@ui/Tablet/Tablet.vue'
import Button from '@/components/@ui/Button/Button.vue'
import TaskWindow from '@/components/@ui/TaskWindow/TaskWindow'
import questionsArt from './questionsArt'
import questionsArtOlder from './questionsArtOlder'
import questionsBio from './questionsBio'
import questionsBioOlder from './questionsBioOlder'
import questionsMath from './questionsMath'
import questionsMathOlder from './questionsMathOlder'

export default {
  name: 'Cinema',
  metaInfo: {
    title: 'В кино',
  },
  components: {
    Tablet,
    Button,
    TaskWindow,
  },
  data() {
    return {
      image: require('./assets/cinema_no_hero.png'),
      start: true,
      test: true,
      showResult: false,
      step: 0,
      currentAnswer: null,
      answers: {
        0: null,
        1: null,
        2: null,
        3: null,
      },
    }
  },
  methods: {
    next() {
      this.currentAnswer = null
      if (this.step + 1 < this.questionsList.length) {
        this.step = this.step + 1
      } else {
        this.test = false
        this.showResult = true
      }
    },
    validate() {
      this.setAnswer(this.isCorrectAnswer())
    },
    setAnswer(answer) {
      const { step } = this
      this.answers[step] = answer
    },
    isCorrectAnswer() {
      return this.questions.answer === this.currentAnswer
    },
    commitResult() {
      this.$store.commit('stop', { result: this.score })
      this.$router.push('/hub')
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    currentAnswer(newAnswer, oldAnswer) {
      if (oldAnswer === null) {
        this.validate()
      }
    },
  },
  computed: {
    questionsList() {
      let questions = this.grade === 1 ? questionsArt : questionsArtOlder
      if (this.currentPerson === 'math') {
        questions = this.grade === 1 ? questionsMath : questionsMathOlder
      }
      if (this.currentPerson === 'bio') {
        questions = this.grade === 1 ? questionsBio : questionsBioOlder
      }
      return questions
    },
    questions() {
      return this.questionsList[this.step]
    },
    answerResult() {
      return this.isCorrectAnswer()
    },
    score() {
      const { answers } = this
      return Object.values(answers)
        .filter(answer => answer).length * 2
    },
    scoreText() {
      const { score } = this
      return `${score} ${plural(score, 'балл', 'балла', 'баллов')}`
    },
    currentPerson() {
      return this.$store.state.currentRoute
    },
    grade() {
      return this.$store.state.grade
    },
  },
}
</script>
<style lang="scss" module>
  @import './Cinema.sass';
</style>
